"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DepositIntent = exports.FractionDiscount = exports.AmountDiscount = exports.DiscountType = exports.UnknownIntent = exports.IntentType = void 0;
var IntentType;
(function (IntentType) {
    IntentType["Deposit"] = "DEPOSIT";
    IntentType["Unknown"] = "UNKNOWN";
})(IntentType || (exports.IntentType = IntentType = {}));
const UnknownIntent = () => ({
    type: IntentType.Unknown,
});
exports.UnknownIntent = UnknownIntent;
var DiscountType;
(function (DiscountType) {
    DiscountType["Amount"] = "AMOUNT";
    DiscountType["Fraction"] = "FRACTION";
})(DiscountType || (exports.DiscountType = DiscountType = {}));
const AmountDiscount = (amount) => ({
    type: DiscountType.Amount,
    amount,
});
exports.AmountDiscount = AmountDiscount;
const FractionDiscount = (fraction) => ({
    type: DiscountType.Fraction,
    fraction,
});
exports.FractionDiscount = FractionDiscount;
const DepositIntent = (period = 10, discount) => ({
    type: IntentType.Deposit,
    collectionPeriod: period,
    discount,
});
exports.DepositIntent = DepositIntent;
//# sourceMappingURL=index.js.map